import React            from 'react';
import { Link }         from 'react-router'
import renderHTML       from 'react-render-html';

class StageButton extends React.Component {
	render() {
		var divclasses = this.props.buttonclass;
		if ( this.props.buttonlink !== "" ) {
			return (
				<Link to={this.props.buttonlink} onClick={(e) => this.props.linkclick(this.props.slug)} >
					<div className={divclasses} id={this.props.id}>
						<div>{renderHTML(this.props.children)}</div>
					</div>
				</Link>
			);
		} else {
			return (
				<div className={divclasses} id={this.props.id}>
					<div>{renderHTML(this.props.children)}</div>
				</div>
			);
		}

	}
}

export default StageButton;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/StageButton.js
 **/